import { render, staticRenderFns } from "./surveyTable.vue?vue&type=template&id=42a6daa2&scoped=true"
import script from "./surveyTable.vue?vue&type=script&lang=js"
export * from "./surveyTable.vue?vue&type=script&lang=js"
import style0 from "./surveyTable.vue?vue&type=style&index=0&id=42a6daa2&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42a6daa2",
  null
  
)

export default component.exports